import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TempoSessaoModule } from './../tempo-sessao/tempo-sessao.module';


import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';


import { RouterModule } from '@angular/router';
import { MenuAcoesGerenciaisComponent } from './menu-acoes-gerenciais/menu-acoes-gerenciais.component';
import { TbReferenciaGerencialComponent } from './menu-acoes-gerenciais/tb-referencia-gerencial/tb-referencia-gerencial.component';
import { MenuAtendimentoMultidisciplinarComponent } from './menu-atendimento-multidisciplinar/menu-atendimento-multidisciplinar.component';
import { SubMenuDiagnosticoMultidisciplinarComponent } from './menu-atendimento-multidisciplinar/sub-menu-diagnostico-multidisciplinar/sub-menu-diagnostico-multidisciplinar.component';
import { SubMenuPlanejamentoAtividadesComponent } from './menu-atendimento-multidisciplinar/sub-menu-planejamento-atividades/sub-menu-planejamento-atividades.component';
import { MenuConfiguracoesComponent } from './menu-configuracoes/menu-configuracoes.component';
import { MenuEstrategicoComponent } from './menu-estrategico/menu-estrategico.component';
import { TbReferenciaEstrategicoComponent } from './menu-estrategico/tb-referencia-estrategico/tb-referencia-estrategico.component';
import { MenuGestaoFinanceiraComponent } from './menu-gestao-financeira/menu-gestao-financeira.component';
import { SubMenuRelatorioFinanceiroComponent } from './menu-gestao-financeira/sub-menu-relatorio/sub-menu-relatorio-financeiro.component';
import { TbReferenciaFinanceiroComponent } from './menu-gestao-financeira/tb-referencia-financeiro/tb-referencia-financeiro.component';
import { MenuGestaoPessoasComponent } from './menu-gestao-pessoas/menu-gestao-pessoas.component';
import { SubMenuGestaoDesempenhoComponent } from './menu-gestao-pessoas/sub-menu-gestao-desempenho/sub-menu-gestao-desempenho.component';
import { SubMenuRelatorioDpComponent } from './menu-gestao-pessoas/sub-menu-relatorio/sub-menu-relatorio-dp.component';
import { TbReferenciaGestaoPessoasComponent } from './menu-gestao-pessoas/tb-referencia-gestao-pessoas/tb-referencia-gestao-pessoas.component';
import { MenuMateriaisComponent } from './menu-materiais/menu-materiais.component';
import { MenuOrganizacaoInternaComponent } from './menu-organizacao-interna/menu-organizacao-interna.component';
import { TbReferenciaOrganizacaoInternaComponent } from './menu-organizacao-interna/tb-referencia-organizacao-interna/tb-referencia-organizacao-interna.component';
import { MenuPedagogicoComponent } from './menu-pedagogico/menu-pedagogico.component';
import { TbReferenciaPedagogicoComponent } from './menu-pedagogico/tb-referencia-pedagogico/tb-referencia-pedagogico.component';
import { MenuPrincipalComponent } from './menu-principal.component';
import { MenuProgramaProjetoComponent } from './menu-programa-projeto/menu-programa-projeto.component';
import { TbProgramasProjetosComponent } from './menu-programa-projeto/tb-referencia-programa-projeto/tb-referencia-programa-projeto.component';
import { MenuRelatoriosGerenciaisComponent } from './menu-relatorios-gerenciais/menu-relatorios-gerenciais.component';
import { MenuSapComponent } from './menu-sap/menu-sap.component';
import { TbReferenciaSapComponent } from './menu-sap/tb-referencia-sap/tb-referencia-sap.component';
import { MenuSecretariaComponent } from './menu-secretaria/menu-secretaria.component';
import { SubMenuRelatorioComponent } from './menu-secretaria/sub-menu-relatorio/sub-menu-relatorio.component';
import { TbReferenciaSecretariaComponent } from './menu-secretaria/tb-referencia-secretaria/tb-referencia-secretaria.component';
import { SubMenuComponent } from './sub-menu/sub-menu.component';



@NgModule({
  declarations: [
    MenuPrincipalComponent,
    MenuConfiguracoesComponent,
    SubMenuComponent,
    MenuOrganizacaoInternaComponent,
    MenuEstrategicoComponent,
    MenuGestaoPessoasComponent,
    MenuSecretariaComponent,
    MenuSapComponent,
    MenuPedagogicoComponent,
    MenuRelatoriosGerenciaisComponent,
    TbReferenciaGestaoPessoasComponent,
    TbReferenciaSecretariaComponent,
    TbReferenciaSapComponent,
    TbReferenciaOrganizacaoInternaComponent,
    TbReferenciaFinanceiroComponent,
    TbReferenciaGerencialComponent,
    MenuProgramaProjetoComponent,
    TbReferenciaEstrategicoComponent,
    SubMenuGestaoDesempenhoComponent,
    MenuGestaoFinanceiraComponent,
    MenuAtendimentoMultidisciplinarComponent,
    SubMenuDiagnosticoMultidisciplinarComponent,
    SubMenuPlanejamentoAtividadesComponent,
    MenuMateriaisComponent,
    MenuAcoesGerenciaisComponent,
    TbReferenciaPedagogicoComponent,
    TbProgramasProjetosComponent,
    SubMenuRelatorioComponent,
    SubMenuRelatorioDpComponent,
    SubMenuRelatorioFinanceiroComponent
  ],
  imports: [
    CommonModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    FlexLayoutModule,
    MatExpansionModule,
    MatButtonModule,
    MatInputModule,
    MatDividerModule,
    MatListModule,
    RouterModule,
    MatTooltipModule,
    TempoSessaoModule,
    MatToolbarModule,
  ],
  exports: [MenuPrincipalComponent]
})
export class MenuPrincipalModule { }
